
import img1 from "../../Assets/Dashboard/graphic-design.png"
const LearningData = [
    {
        key: 1,
        img: img1,
        title: "Accounting & Finance",
        duration: " 15",
        videos: "20",
        btn: "Start Course",
        link:"/learning-path/accounting&finance"

    },
    {
        key: 2,
        img: img1,
        title: "Digital Marketing",
        duration: " 15",
        videos: "20",
        btn: "Start Course",
        link:"/learning-path/digitalmarketing"

    },
    {
        key: 3,
        img: img1,
        title: "Graphic Designing",
        duration: " 15",
        videos: "20",
        btn: "Start Course",
        link:"/learning-path/graphicdesigning"
    },
    
    {
        key: 4,
        img: img1,
        title: "Website Development",
        duration: " 15",
        videos: "20",
        btn: "Start Course",
        link:"/learning-path/webdevelopment"

    },
    
    {
        key: 5,
        img: img1,
        title: "Virtual Assistant",
        duration: " 15",
        videos: "20",
        btn: "Start Course",
        link:"/learning-path/virtualassistant"

    },
]
export default LearningData;